import React from 'react';
import { ElephantFind } from './ElephantHunt';
import { motion } from 'framer-motion';
import PaintTitle from './PaintTitle';
import { Link } from 'react-router-dom';

function Timeline({ projects, focusQuery = '' }) {
    const sortedProjects = projects;

    const lineVariants = {
        hidden: { height: 0 },
        visible: {
            height: '100%',
            transition: {
                duration: 2,
                ease: "easeIn"
            }
        }
    };

    const itemVariants = {
        hidden: { opacity: 0, y: 30 },
        visible: {
            opacity: 1,
            y: 0,
            transition: {
                duration: 0.5
            }
        }
    };

    return (
        <div className="timeline-container" id="projects">
            <PaintTitle className="timeline-title">Selected projects</PaintTitle>

            <div className="timeline">
                <motion.div
                    className="timeline-line"
                    initial="hidden"
                    whileInView="visible"
                    viewport={{ once: true }}
                    variants={lineVariants}
                ><ElephantFind id="timeline" className="elephant-endstop" /></motion.div>

                {sortedProjects.map((project, index) => (
                    <motion.div
                        key={index}
                        id={project.id}
                        className="timeline-item"
                        variants={itemVariants}
                        initial="hidden"
                        whileInView="visible"
                        viewport={{ once: true, amount: 0.3 }}
                    >
                        <div className="timeline-dot"></div>
                        <div className="timeline-content">
                            <div className="timeline-date">{project.date}</div>
                            <h3 className="timeline-project-title"><Link to={`/project/${project.id}${focusQuery}`}>{project.title}</Link></h3>
                            <p className="timeline-project-preview">
                                {project.summary}
                                <Link className="timeline-read-more" to={`/project/${project.id}${focusQuery}`}>View project</Link>
                            </p>
                        </div>
                    </motion.div>
                ))}
            </div>
        </div>
    );
}

export default Timeline;